import { render } from "./BlogLeftSidebarPage.vue?vue&type=template&id=d80afb82"
import script from "./BlogLeftSidebarPage.vue?vue&type=script&lang=js"
export * from "./BlogLeftSidebarPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__